import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteCompanyTypeMutation} from 'api';
import {useSnackbar} from 'notistack';

function CompanyTypeDeleteIconButton({companyTypeId}) {
  const [deleteCompanyType, deleteCompanyTypeResult] = useDeleteCompanyTypeMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteCompanyType(companyTypeId).unwrap();
      enqueueSnackbar('CompanyType deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting CompanyType`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete CompanyType</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this CompanyType?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteCompanyTypeResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteCompanyTypeResult.isLoading}
            color="error"
            endIcon={deleteCompanyTypeResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteCompanyTypeResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default CompanyTypeDeleteIconButton;
